import React from 'react'

import { CircleIcon, Flex, Tooltip, Typography } from 'components'
import InlineEditableField from 'module/Management/components/InlineEditableField'

import i18n from 'translations'

import { StyledWrapper } from './AiAssistantStyled'
import AiAssistantForm, { AI_ASSISTANT_FORM } from './AiAssistantForm'

interface AiAssistantProps {
  onSubmit: (value: boolean) => void
  value: boolean
}

const AiAssistant: React.FC<AiAssistantProps> = ({ onSubmit, value }) => {
  const initialValues = { aiEnabled: value }

  return (
    <StyledWrapper>
      <InlineEditableField
        description={(
          <Typography padding="4px 0">
            {value
              ? i18n.t('module:Management:General:on')
              : i18n.t('module:Management:General:off')}
          </Typography>
        )}
        editableComponent={(callback) => (
          <AiAssistantForm
            initialValues={initialValues}
            onSubmit={callback}
          />
        )}
        formName={AI_ASSISTANT_FORM}
        title={(
          <Flex alignItems="center" gap="10px" padding="1px 0">
            <Typography bold>
              {i18n.t('module:Management:General:aiWritingAssistant')}
            </Typography>
            <Tooltip title={i18n.t('module:Management:General:aiWritingAssistantTooltip')} inline>
              <CircleIcon
                cursor="pointer"
                icon="info"
                iconSize={16}
                size={24}
              />
            </Tooltip>
          </Flex>
        )}
        value={value}
        onSubmit={onSubmit}
      />
    </StyledWrapper>
  )
}

export default AiAssistant
